import { useEffect, useState, ReactNode } from 'react'
import { useAtom } from 'jotai'
import { authAtom } from '@/store/auth/authAtom'
import { GET } from '@/api/api'
import { ScreenLoader } from '@/components/loader/ScreenLoader'
import { useLocation } from 'react-router-dom'
import { ROLE } from '@/constants/roles'

type RequireAuthProps = {
  children: ReactNode
}

export const RequireAuth = ({ children }: RequireAuthProps) => {
  const location = useLocation()
  const [user, setUser] = useAtom(authAtom)
  const [checked, setChecked] = useState(false)

  useEffect(() => {
    GET('/api/user')
      .then((res: any) => {
        if (res.status === 200) {
          setUser(res.data)
        } else {
          setUser(null)
        }
      })
      .catch(() => {
        setUser(null)
      })
      .finally(() => {
        setChecked(true)
      })
  }, [location.pathname])

  if (!checked) {
    return <ScreenLoader />
  }

  if (user === null) {
    window.location.href = '/auth/login?session_timeout=true'
    return null
  }

  if (/^\/users(\/.*)?$/.test(location.pathname) && user?.role !== ROLE.ADMIN) {
    window.location.href = '/top'
    return null
  }

  return <>{children}</>
}
